import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar";

export default function Nutricion() {
  return (
    <div>
      <NavBar user={{ role: "nutricionista" }} />
      <main style={{ padding: "1rem" }}>
        <Outlet /> {/* 👈 Aquí se cargará NutricionistaHome, Pacientes, Calendario, etc */}
      </main>
    </div>
  );
}
